import React from "react";
import TwoOptionModal from "components/MainApp/atoms/Modals/TwoOptionModal";
import i18n from "i18n";

const EditExitModal = ({ open, handleClose, handleConfirm }) => {
  const title = i18n.t("client.edition.exit.question");
  const subtitle = i18n.t("dont.save.lose.changes");

  return (
    <TwoOptionModal
      open={open}
      title={title}
      subtitle={subtitle}
      closeLabel={i18n.t("do.not.save")}
      confirmLabel={i18n.t("save").toUpperCase()}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
    />
  );
};

export default EditExitModal;
